const dashboards = [
  {
    año:"2021",
    
    url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2021/Dashboard1"
  },
  {
  año:"2020",
  
  url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2020/Dashboard1"
  },
  {
    año:"2019",
    
    url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2019/Dashboard1"
  },

  {
  año:"2018",
  
  url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2018/Dashboard1"
  },

  {
    año:"2017",
    
    url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2017/Dashboard1"
  },
  {
    año:"2016",
    
    url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2016/Dashboard1"
    },
 {
  año:"2015",
  
  url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2015/Dashboard1"
  },
    {
  año:"2014",
  
  url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2014/Dashboard1"
  },
    {
  año:"2013",
  
  url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2013/Dashboard1"
  },
    {
  año:"2012",
  
  url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2012/Dashboard1"
  },
    {
  año:"2011",
  
  url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2011/Dashboard1"
  },
  {
    año:"2010",
    
    url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2010/Dashboard1"
  },
  {
  año:"2009",
  
  url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2009/Dashboard1"
  },
  {
    año:"2008",
    
    url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2008/Dashboard1"
  },

  {
  año:"2007",
  
  url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2007/Dashboard1"
  },

  {
    año:"2006",
    
    url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2006/Dashboard1"
  },
  {
    año:"2005",
    
    url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2005/Dashboard1"
    },
 {
  año:"2004",
  
  url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2004/Dashboard1"
  },
    {
  año:"2003",
  
  url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2003/Dashboard1"
  },
    {
  año:"2002",
  
  url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2002/Dashboard1"
  },
    {
  año:"2001",
  
  url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2001/Dashboard1"
  },
  {
  año:"2000",
  
  url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10ao2000/Dashboard1"
  },
  
];

export default dashboards;
